import React, { useRef, useState } from 'react';
import MathToolbar from './MathToolbar';
import MathText from './MathText';

const MathField = ({ value, onChange, multiline = false, rows = 4, placeholder, style, showPreview = true }) => {
  const ref = useRef(null);
  const [showToolbar, setShowToolbar] = useState(false);

  const inputProps = {
    ref,
    value: value || '',
    onChange: (e) => onChange(e.target.value),
    onFocus: () => setShowToolbar(true),
    placeholder,
    style: { width: '100%', boxSizing: 'border-box', ...style },
  };

  return (
    <div style={{ width: '100%' }}>
      {showToolbar && (
        <MathToolbar targetRef={ref} value={value} onChange={onChange} />
      )}
      {multiline ? (
        <textarea {...inputProps} rows={rows} />
      ) : (
        <input type="text" {...inputProps} />
      )}
      {showPreview && value && (
        <div style={{ marginTop: '4px', padding: '6px 10px', background: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '6px', fontSize: '13px', color: '#0f172a' }}>
          <span style={{ fontSize: '10px', color: '#64748b', fontWeight: 600, marginRight: '6px' }}>Önizleme:</span>
          <MathText>{value}</MathText>
        </div>
      )}
    </div>
  );
};

export default MathField;
